import * as util from '../apiUtils';
import * as common from '../apiCommon';
import { ITEM_GROUP_PRICE } from '../../constants/constant_doc_types';
import { getLocalDatetime } from '../../utils/local_date';

export function saveItemGroupPrice(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const doc = {
    doc_type: ITEM_GROUP_PRICE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    reference_id: util.toStringText(data.reference_id),
    available_from: getLocalDatetime(data.available_from),
    available_to: getLocalDatetime(data.available_to),
    currency_id: data.currency_id,
    price_group_id: data.price_group_id,
    item_id: data.item_id,
    retail_price: data.retail_price,
    sale_price: data.sale_price,
    custom_fields: data.custom_fields,
  };

  return common.saveDoc(app, {
    source: data,
    doc,
    user,
  });
}

export function deleteItemGroupPrice(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: ITEM_GROUP_PRICE,
  });
}

export function fetchItemGroupPriceById(app, params) {
  const { id } = params;
  const docType = ITEM_GROUP_PRICE;
  return common.getDoc(app, { id, docType }, { assemble_custom_fields: true });
}
